import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { FormControlsUtilsModule } from '../form-controls-utils/form-controls-utils.module';
import { TextControlComponent } from './text-control/text-control.component';
import { TextFormControlComponent } from './text-form-control.component';



@NgModule({
  declarations: [
    TextFormControlComponent,
    TextControlComponent
  ],
  exports: [
    TextFormControlComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    FormControlsUtilsModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatIconModule,
    MatButtonModule,
    TranslateModule
  ]
})
export class TextFormControlModule { }
